import React, { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import collapseDown from '../../assets/collapse-down.svg';
import collapseUp from '../../assets/collapse-up.svg';
import ProfileWidgets from './ProfileWidgets';

// Helper function to compare values
function compareValues(key) {
    return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            return 0;
        }
        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];
        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return comparison;
    };
}

const ProfileWidgetCategory = ({ groupWidgets, getSelectedWidgets, onWidgetChange, s }) => {
    const [collapse, setCollapse] = useState({});

    const handleCollapse = (widgetItem) => {
        setCollapse(prev => ({ ...prev, [widgetItem]: !prev[widgetItem] }));
    };

    return (
        <>
            {Object.keys(groupWidgets).map(widgetItem => {
                // Group widgets by CategoryName
                const widgetsByCategory = groupWidgets[widgetItem]
                    .sort(compareValues('Name'))
                    .reduce((acc, widget) => {
                        const category = widget.CategoryName || '';
                        if (!acc[category]) acc[category] = [];
                        acc[category].push(widget);
                        return acc;
                    }, {});

                return (
                    <div key={widgetItem}>
                        <div className={s.widgetTitle} style={{ display: 'flex', alignItems: 'center' }} >
                            <img onClick={() => handleCollapse(widgetItem)}
                                src={collapse[widgetItem] ? collapseDown : collapseUp}
                                alt="Collapse section"
                                style={{ marginRight: 8 }}
                            />
                            <h4 style={{ margin: 0 }}>{widgetItem}</h4>
                            <div style={{ marginLeft: 'auto' }}  className={s.profileWidgetCategoryContent}>
                                <label className={s.container} style={{ display: 'flex', alignItems: 'center' }}>

                                    <input
                                        type="checkbox"
                                        id={`cbSelectAll-${widgetItem}`}
                                        value="Select all"
                                        onChange={e => {
                                            // Select all widgets in all categories for this group
                                            const allWidgets = Object.values(widgetsByCategory).flat();
                                            const allWidgetIds = allWidgets.map(w => w.WidgetId);
                                            if (e.target.checked) {
                                                onWidgetChange(allWidgetIds, false);
                                            } else {
                                                onWidgetChange(allWidgetIds, true);
                                            }
                                        }}
                                        checked={(() => {
                                            const allWidgets = Object.values(widgetsByCategory).flat();
                                            const allWidgetIds = allWidgets.map(w => w.WidgetId);
                                            // Check if all widgets in this group are selected
                                            return allWidgetIds.length > 0 && allWidgetIds.every(id => getSelectedWidgets(allWidgets).includes(id));
                                        })()}
                                    />
                                    <span className={s.selectall}>Select all</span>
                                    <span className={s.checkmark} htmlFor={`cbSelectAll-${widgetItem}`}></span>
                                </label>
                            </div>
                        </div>
                        <Collapse in={collapse[widgetItem]}>
                            <div>
                                {Object.keys(widgetsByCategory).map(category => (
                                    <ProfileWidgets
                                        key={`${widgetItem}-${category}`}
                                        groupName={`${category ? category : widgetItem}`}
                                        widgets={widgetsByCategory[category]}
                                        profileWidgets={getSelectedWidgets(widgetsByCategory[category])}
                                        onWidgetChange={onWidgetChange}
                                    />
                                ))}
                            </div>
                        </Collapse>
                    </div>
                );
            })}
        </>
    );
};

export default ProfileWidgetCategory;
